import React, { ReactElement } from "react";
import { useFlag } from "@unleash/proxy-client-react";
import { useTranslation } from "react-i18next";
import {
  I18N_NAMESPACES,
  MOBILE_NAVBAR_ACCORDIONS,
  UNLEASH_NON_WINE_SPECIAL_PACKS,
} from "../../../helpers/constants";
import urlPatterns from "../../../urls";
import AccordionItem from "../AccordionItem";
import {
  AccordionTopPart,
  StyledChevron,
  AccordionWrapper,
  AccordionContentWrapper,
} from "../MobileHeaderNavbar/style";
import { useAppContext } from "../../organisms/Layout/context";
import { MemberLayoutInfo_collections } from "../../../types/__generated__/MemberLayoutInfo";

interface MobileProductsAccordionProps {
  openAccordion: string | undefined;
  setOpenAccordion: Function;
}

const MobileProductsAccordion = ({
  openAccordion,
  setOpenAccordion,
}: MobileProductsAccordionProps): ReactElement => {
  const isThisAccordionOpen = openAccordion === MOBILE_NAVBAR_ACCORDIONS.PRODUCTS;
  const { t } = useTranslation([I18N_NAMESPACES.COMMON]);
  const isNonWineSpecialPacksEnabled = useFlag(UNLEASH_NON_WINE_SPECIAL_PACKS);
  const { collections } = useAppContext();

  const itemHeightInPx = 55;
  const accordionTopPartHeightInPx = 90;
  const accordionContentWrapperPaddingInPx = 32;
  const bothBordersHeightInPx = 2;

  const collectionsLength = collections?.length || 0;
  const itemsInAccordion = collectionsLength + (isNonWineSpecialPacksEnabled ? 1 : 0);

  const minHeight =
    accordionTopPartHeightInPx + accordionContentWrapperPaddingInPx + itemHeightInPx + bothBordersHeightInPx;
  const height = minHeight + itemHeightInPx * itemsInAccordion;

  return (
    <AccordionWrapper
      open={isThisAccordionOpen}
      height={height}
      onClick={() => setOpenAccordion(isThisAccordionOpen ? "" : MOBILE_NAVBAR_ACCORDIONS.PRODUCTS)}
    >
      <AccordionTopPart isThisAccordionOpen={isThisAccordionOpen}>
        {t("common:products")}
        <StyledChevron open={isThisAccordionOpen} />
      </AccordionTopPart>
      <AccordionContentWrapper open={isThisAccordionOpen} height={height}>
        <AccordionItem i18nKey={"common:allProducts"} url={urlPatterns.ALL_PRODUCT_COLLECTIONS} />
        {isNonWineSpecialPacksEnabled && (
          <AccordionItem i18nKey={"common:specialPacks"} url={urlPatterns.ALL_SPECIAL_PACKS} />
        )}
        {collections?.map((collection: MemberLayoutInfo_collections | null) => (
          <AccordionItem
            i18nKey={collection?.name || ""}
            url={urlPatterns.PRODUCT_COLLECTION(collection?.slug)}
            key={collection?.slug}
          />
        ))}
      </AccordionContentWrapper>
    </AccordionWrapper>
  );
};

export default MobileProductsAccordion;
